import { render, staticRenderFns } from "./devolutionTicket.vue?vue&type=template&id=20c3b584"
import script from "./devolutionTicket.vue?vue&type=script&lang=js"
export * from "./devolutionTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports